import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { CredentialsClient, credentialsApiRef } from './api/CredentialsApi';

export const credentialsPlugin = createPlugin({
  id: 'credentials',
  routes: { root: rootRouteRef },
  apis: [
    createApiFactory({
      api: credentialsApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new CredentialsClient({ discoveryApi, fetchApi }),
    }),
  ],
});

/** The credentials list, mounted at /credentials. */
export const CredentialsPage = credentialsPlugin.provide(
  createRoutableExtension({
    name: 'CredentialsPage',
    component: () =>
      import('./components/CredentialsPage').then(m => m.CredentialsPage),
    mountPoint: rootRouteRef,
  }),
);
